import {
  FETCH_SHIPMENT_TYPE_DETAILS,
  FETCH_SHIPMENT_TYPE_DETAILS_FAILURE,
  FETCH_SHIPMENT_TYPE_DETAILS_SUCCESS,
  FETCH_SHIPMENTS,
} from './types';

const fetchShipmentTypeDetails = (payload) => ({
  type: FETCH_SHIPMENT_TYPE_DETAILS,
  ...payload,
});

const fetchShipmentTypeDetailsSuccess = (payload) => ({
  type: FETCH_SHIPMENT_TYPE_DETAILS_SUCCESS,
  ...payload,
});

const fetchShipmentTypeDetailsFailure = (payload) => ({
  type: FETCH_SHIPMENT_TYPE_DETAILS_FAILURE,
  ...payload,
});

const fetchShipments = (payload) => ({
  type: FETCH_SHIPMENTS,
  ...payload,
});

export {
  fetchShipmentTypeDetails,
  fetchShipmentTypeDetailsSuccess,
  fetchShipmentTypeDetailsFailure,
  fetchShipments,
};
